import { Response } from '_metronic/helpers'

/** Os 16 tipos do enum `TipoDispositivo` do backend (14 do Telekit + 2 Hilab). */
export type TipoDispositivoGestao =
  | 'BALANCA'
  | 'OXIMETRO'
  | 'TERMOMETRO'
  | 'PRESSAO'
  | 'CAMERA'
  | 'OTOSCOPIO'
  | 'INSPECAO'
  | 'GLICOSIMETRO'
  | 'ESTETOSCOPIO'
  | 'OFTALMOSCOPIO'
  | 'DERMATOSCOPIO'
  | 'RETINOGRAFO'
  | 'DOPPLER'
  | 'ECG'
  | 'HILAB_CORUJA'
  | 'HILAB_LENS'

export const TIPOS_DISPOSITIVO: TipoDispositivoGestao[] = [
  'BALANCA',
  'OXIMETRO',
  'TERMOMETRO',
  'PRESSAO',
  'CAMERA',
  'OTOSCOPIO',
  'INSPECAO',
  'GLICOSIMETRO',
  'ESTETOSCOPIO',
  'OFTALMOSCOPIO',
  'DERMATOSCOPIO',
  'RETINOGRAFO',
  'DOPPLER',
  'ECG',
  'HILAB_CORUJA',
  'HILAB_LENS',
]

export type SituacaoDispositivo =
  | 'EM_ESTOQUE'
  | 'EM_USO'
  | 'RESERVA'
  | 'EM_MANUTENCAO'
  | 'EM_CALIBRACAO'
  | 'EXTRAVIADO'
  | 'BAIXADO'

export const SITUACOES_DISPOSITIVO: SituacaoDispositivo[] = [
  'EM_ESTOQUE',
  'EM_USO',
  'RESERVA',
  'EM_MANUTENCAO',
  'EM_CALIBRACAO',
  'EXTRAVIADO',
  'BAIXADO',
]

export type RegimeDispositivo = 'LAUDUZ' | 'VENDIDO'
export const REGIMES_DISPOSITIVO: RegimeDispositivo[] = ['LAUDUZ', 'VENDIDO']

export type ClasseRiscoDispositivo = 'I' | 'II' | 'III' | 'IV'
export const CLASSES_RISCO: ClasseRiscoDispositivo[] = ['I', 'II', 'III', 'IV']

export type MotivoBaixaDispositivo =
  | 'VENDA'
  | 'DESCARTE'
  | 'EXTRAVIO'
  | 'DEFEITO_IRRECUPERAVEL'
  | 'OUTRO'
export const MOTIVOS_BAIXA: MotivoBaixaDispositivo[] = [
  'VENDA',
  'DESCARTE',
  'EXTRAVIO',
  'DEFEITO_IRRECUPERAVEL',
  'OUTRO',
]

export type MotivoFimAlocacao =
  | 'TROCA'
  | 'MANUTENCAO'
  | 'CALIBRACAO'
  | 'REMANEJAMENTO'
  | 'BAIXA'
  | 'OUTRO'
export const MOTIVOS_FIM_ALOCACAO: MotivoFimAlocacao[] = [
  'TROCA',
  'MANUTENCAO',
  'CALIBRACAO',
  'REMANEJAMENTO',
  'BAIXA',
  'OUTRO',
]

export type Referencia = { id: number; nome: string }

export type MaletaAtual = {
  idTelekit: number
  identificador?: number | null
  padrao?: boolean | null
  idAlocacao: number
  dtInicio?: string | null
}

export type DispositivoGestaoList = {
  id: number
  empresa?: Referencia | null
  tipo: TipoDispositivoGestao
  descricao?: string | null
  serie: string
  fabricante?: string | null
  modelo?: string | null
  patrimonio?: string | null
  macAddress?: string | null
  situacao: SituacaoDispositivo
  regime: RegimeDispositivo
  ativo?: boolean
  fornecedor?: Referencia | null
  garantiaAte?: string | null
  periodicidadeCalibracaoMeses?: number | null
  dtUltimaCalibracao?: string | null
  dtProximaCalibracao?: string | null
  maletaAtual?: MaletaAtual | null
}

export type DispositivoGestaoView = DispositivoGestaoList & {
  lote?: string | null
  udiDi?: string | null
  udiPi?: string | null
  classeRisco?: ClasseRiscoDispositivo | null
  registroAnvisa?: string | null
  registroAnvisaValidade?: string | null
  certificacaoAnatel?: string | null
  certificacaoInmetro?: string | null
  firmware?: string | null
  dtAquisicao?: string | null
  notaFiscal?: string | null
  motivoBaixa?: MotivoBaixaDispositivo | null
  dtBaixa?: string | null
  destinoBaixa?: string | null
  observacoes?: string | null
  dataInclusao?: string
  dataAlteracao?: string
}

/**
 * Corpo de POST/PUT de `/dispositivos/gestao`. No PUT, campo patrimonial ausente ou vazio LIMPA o
 * valor salvo: a tela manda sempre o objeto completo (ver `paraDto`).
 */
export type DispositivoGestaoDto = {
  idEmpresa: number | null
  tipo: TipoDispositivoGestao | null
  serie: string | null
  fabricante: string | null
  modelo: string | null
  patrimonio: string | null
  macAddress: string | null
  regime: RegimeDispositivo | null
  lote: string | null
  udiDi: string | null
  udiPi: string | null
  classeRisco: ClasseRiscoDispositivo | null
  registroAnvisa: string | null
  registroAnvisaValidade: string | null
  certificacaoAnatel: string | null
  certificacaoInmetro: string | null
  firmware: string | null
  dtAquisicao: string | null
  idFornecedor: number | null
  notaFiscal: string | null
  garantiaAte: string | null
  periodicidadeCalibracaoMeses: number | null
  dtUltimaCalibracao: string | null
  situacao: SituacaoDispositivo | null
  motivoBaixa: MotivoBaixaDispositivo | null
  dtBaixa: string | null
  destinoBaixa: string | null
  observacoes: string | null
}

export type AlocacaoDispositivoList = {
  id: number
  ativo: boolean
  telekit?: { id: number; identificador?: number | null; padrao?: boolean | null } | null
  empresa?: Referencia | null
  dtInicio?: string | null
  dtFim?: string | null
  motivoFim?: MotivoFimAlocacao | null
  observacao?: string | null
  aeTitle?: string | null
  modalidade?: string | null
  descricao?: string | null
}

export type AfericaoDispositivoList = {
  id: number
  data?: string | null
  tipoInformacao?: { id: number; descricao?: string | null } | null
  idAtendimento?: number | null
  empresa?: Referencia | null
}

export type AfericaoDispositivoResumo = {
  quantidade: number
  ultimaAfericao?: string | null
}

export type DispositivosGestaoQueryResponse = Response<DispositivoGestaoList[]>
export type AfericoesQueryResponse = Response<AfericaoDispositivoList[]>
